import { ChangeDetectionStrategy, Component, Input, OnChanges, signal } from '@angular/core';
import { loadScript } from '../../../lib/load-script';
import { sleep } from '../../../lib/sleep';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    QRCode: any;
  }
}

@Component({
  selector: 'app-qr-code',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  templateUrl: './qr-code.component.html',
  styleUrl: './qr-code.component.scss',
})
export class QrCodeComponent implements OnChanges {
  dataUrl = signal<string>(undefined);
  @Input() content: string;

  async ngOnChanges() {
    await loadScript('https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js');
    await sleep(10);
    const div = document.createElement('div');
    new window.QRCode(div, {
      text: this.content,
      width: 256,
      height: 256,
      colorDark: '#000000',
      colorLight: '#ffffff',
      correctLevel: window.QRCode.CorrectLevel.L,
    });
    await sleep(100);
    this.dataUrl.set(div.querySelector('img').src);
  }
}
